import { render } from "./AddAdminView.vue?vue&type=template&id=076e079d"
import script from "./AddAdminView.vue?vue&type=script&lang=js"
export * from "./AddAdminView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__